import { Link } from "gatsby";
import React, { useState, useEffect } from "react";
import Sidebar from "../../common/sidebar";
import { GatsbyImage } from "gatsby-plugin-image";
import NavMenu from "./navmenu";
import NewletterModal from "../../common/NewletterModal";

const Header = ({ data, socialLinks }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  // Sticky Menu Area start
  useEffect(() => {
    window.addEventListener("scroll", sticky);
    window.addEventListener("wheel", sticky);
    return () => {
      window.removeEventListener("scroll", sticky);
      window.removeEventListener("wheel", sticky);
    };
  });

  const sticky = (e) => {
    const header = document.querySelector(".header-main");
    const scrollTop = window.scrollY;
    scrollTop >= 40
      ? header.classList.add("sticky")
      : header.classList.remove("sticky");
  };
  // Sticky Menu Area End
  return (
    <>
      <header className="header1 bg-[var(--clr-bg-footer)]">
        <div id="header-sticky" className="header-main header-main1">
          <div className="container container-big">
            <div className="row align-items-center">
              <div className="col-xl-12 col-lg-12">
                <div className="header-main-content-wrapper min-h-[80px]">
                  <div className="header-main-left header-main-left-header1">
                    <div className="header-logo header1-logo my-auto">
                      <Link
                        className="text-inherit no-underline logo-bl"
                        to="/"
                      >
                        <GatsbyImage
                          image={data.logo.image.asset.gatsbyImageData}
                          alt={data.logo.alt}
                          loading="eager"
                          objectFit="contain"
                          className="w-full h-auto xl:max-w-[200px]"
                        />
                      </Link>
                    </div>
                    <div className="main-menu main-menu1 d-none d-xl-block">
                      <nav id="mobile-menu" className="xl:pl-0 2xl:pl-5">
                        <NavMenu menu={data.menuLinks} />
                      </nav>
                    </div>
                  </div>
                  <div className="header-main-right header-main-right-header1">
                    <button
                      className="border-btn-rounded d-none d-lg-inline-flex no-underline cursor-pointer"
                      onClick={() => setOpenModal(true)}
                    >
                      {data.ctaButtonText}
                    </button>

                    <div className="menu-bar d-xl-none">
                      <span
                        className="side-toggle"
                        onClick={() => setShowSidebar(true)}
                      >
                        <div className="bar-icon">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* sidebar start */}
      <Sidebar
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        menu={data.menuLinks}
        logo={data.logo}
        socialLinks={socialLinks}
      />

      {openModal && <NewletterModal closeModal={() => setOpenModal(false)} />}
    </>
  );
};

export default Header;
